import client from './client'
import type { User } from '@/types'

export interface AuthTokens {
  access_token: string
  refresh_token: string
  user: User
}

export const authApi = {
  async login(username: string, password: string) {
    const { data } = await client.post('/auth/login', { username, password })
    // API returns { success: true, data: { access_token, refresh_token, user, ... } }
    return data.data as AuthTokens
  },

  async logout() {
    await client.post('/auth/logout')
  },

  async getProfile() {
    const { data } = await client.get('/auth/me')
    return data as User
  },

  async refreshToken(refreshToken: string) {
    const { data } = await client.post('/auth/refresh', { refresh_token: refreshToken })
    // API returns { success: true, data: { access_token, refresh_token, ... } }
    return data.data as { access_token: string; refresh_token: string }
  }
}
